// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___XM4YG","root_slider":"style-module__root_slider___GidU8","root__item":"style-module__root__item___rHXlS","root__item_wrapper":"style-module__root__item_wrapper____Xbgi","root__item_link":"style-module__root__item_link___szARU","root__item_title":"style-module__root__item_title___s7Yc8","root__item_description":"style-module__root__item_description___K_f5P","root__item_image":"style-module__root__item_image___TrmqG"};
    if(module.hot) {
      // 1697460473828
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  